import { DateTime } from 'luxon'
import { getP } from 'redux-polyglot'
import api from '../libs/api'
import youtubeApi from '../libs/youtube'

/**
 * Actions for dismissing an error
 */
export const DISMISS_ERROR = 'YOUTUBE/DISMISS_ERROR'

export const dismissError = () => ({
  type: DISMISS_ERROR
})

/**
 * Actions for fetching YouTube sections to load from API
 */
export const FETCH_SECTIONS_REQUEST = 'YOUTUBE/SECTIONS/FETCH_REQUEST'
export const FETCH_SECTIONS_SUCCESS = 'YOUTUBE/SECTIONS/FETCH_SUCCESS'
export const FETCH_SECTIONS_FAILURE = 'YOUTUBE/SECTIONS/FETCH_FAILURE'

const fetchSectionsRequest = () => ({
  type: FETCH_SECTIONS_REQUEST
})

const fetchSectionsSuccess = sections => ({
  type: FETCH_SECTIONS_SUCCESS,
  payload: {
    sections
  }
})

const fetchSectionsFailure = error => ({
  type: FETCH_SECTIONS_FAILURE,
  payload: error instanceof Error ? error : new Error(error),
  error: true
})

export const loadContent = () => (dispatch, getState) => {
  dispatch(fetchSectionsRequest())
  return api
    .getYouTubeContent()
    .then(res => res.json())
    .then(
      response => {
        if (response.status === 200) {
          dispatch(fetchSectionsSuccess(response.sections))
          return Promise.all(
            response.sections.map(section => dispatch(loadVideos(section)))
          )
        } else {
          return dispatch(fetchSectionsFailure(response.reason))
        }
      },
      () => dispatch(fetchSectionsFailure(getP(getState()).t("tv_youtube.sections_loading_error", { _: "An error occurred while loading details about YouTube content to display" })))
    )
}

/**
 * Actions for fetching videos from YouTube API
 */
export const FETCH_VIDEOS_REQUEST = 'YOUTUBE/VIDEOS/FETCH_REQUEST'
export const FETCH_VIDEOS_SUCCESS = 'YOUTUBE/VIDEOS/FETCH_SUCCESS'
export const FETCH_VIDEOS_FAILURE = 'YOUTUBE/VIDEOS/FETCH_FAILURE'

const fetchVideosRequest = sectionId => ({
  type: FETCH_VIDEOS_REQUEST,
  payload: {
    sectionId
  }
})

const fetchVideosSuccess = (sectionId, videos) => ({
  type: FETCH_VIDEOS_SUCCESS,
  payload: {
    sectionId,
    videos
  }
})

const fetchVideosFailure = (sectionId, error) => ({
  type: FETCH_VIDEOS_FAILURE,
  payload: error instanceof Error ? error : new Error(error),
  error: true,
  meta: {
    sectionId
  }
})

const sanitizeVideos = items => {
  const videos = []
  if (typeof items === 'undefined' || items.length === 0) {
    return videos
  }
  items.forEach(item => {
    let videoId = null
    if (item.kind === 'youtube#video') {
      videoId = item.id
    } else if (item.kind === 'youtube#searchResult' && item.id.kind === 'youtube#video') {
      videoId = item.id.videoId
    } else if (item.kind === 'youtube#playlistItem' && item.snippet.resourceId.kind === 'youtube#video') {
      videoId = item.snippet.resourceId.videoId
    }
    if (videoId !== null) {
      videos.push({
        id: videoId,
        name: item.snippet.title,
        desc: item.snippet.description,
        img: item.snippet.thumbnails.high.url,
        created: DateTime.fromISO(item.snippet.publishedAt).toSeconds(),
        lastUpdated: Date.now()
      })
    }
  })
  return videos
}

const loadVideos = section => (dispatch, getState) => {
  dispatch(fetchVideosRequest(section.id))
  return youtubeApi(section.endpoint, 'GET', section.params)
    .then(res => res.json())
    .then(
      response => {
        return dispatch(fetchVideosSuccess(section.id, sanitizeVideos(response.items)))
      },
      () => dispatch(fetchVideosFailure(section.id, getP(getState()).t("tv_youtube.videos_loading_error", { _: "An error occurred while loading YouTube Videos for this category" })))
    )
}

/**
 * Actions for focusing a content section
 */
export const FOCUS_SECTION = 'YOUTUBE/FOCUS_SECTION'

export const focusSection = sectionId => ({
  type: FOCUS_SECTION,
  payload: {
    sectionId
  }
})

/**
 * Actions for focusing a content section
 */
export const FOCUS_POSITION = 'YOUTUBE/FOCUS_POSITION'

export const focusPosition = (sectionId, position) => ({
  type: FOCUS_POSITION,
  payload: {
    sectionId,
    position
  }
})
